import { ASSETS } from "../lib/assets";

export function MascotBubble({ text, testId = "mascot-bubble" }) {
  if (!text) return null;
  return (
    <div className="wmleye-mascot-bubble" data-testid={testId} role="status" aria-live="polite">
      <img
        className="wmleye-mascot-bubble__img"
        src={ASSETS.mascotOllie}
        alt="Ollie the owl"
      />
      <div className="wmleye-mascot-bubble__text" data-testid={`${testId}-text`}>
        {text}
      </div>
    </div>
  );
}
